import { useFlags } from "flagsmith/react";
import { USER_FLAGS_ENUM } from "@utils/featureFlags";

/**
 * Hook para controlar o campo de frete (CIF/FOB) via feature flag.
 *
 * - Flag ON: campo habilitado (comportamento normal)
 * - Flag OFF: campo desabilitado (visível, porém sem interação)
 *
 * Pode ser combinado com outras regras de negócio (ex: lockDefaultFreightType)
 * usando o operador OR: `disabled={isFreightDisabled || lockDefaultFreightType}`
 */
export const useFreightControl = () => {
  const flags = useFlags([USER_FLAGS_ENUM.ENABLE_FREIGHT_CONTROL]);
  const isFreightEnabled =
    flags[USER_FLAGS_ENUM.ENABLE_FREIGHT_CONTROL]?.enabled !== false;

  return {
    isFreightEnabled,
    isFreightDisabled: !isFreightEnabled,
  };
};
